import { render, staticRenderFns } from "./final-exam-dashboard-button-component.vue?vue&type=template&id=898d4a74&scoped=true&"
import script from "./final-exam-dashboard-button-component.vue?vue&type=script&lang=ts&"
export * from "./final-exam-dashboard-button-component.vue?vue&type=script&lang=ts&"
import style0 from "./final-exam-dashboard-button-component.vue?vue&type=style&index=0&id=898d4a74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898d4a74",
  null
  
)

export default component.exports